module.exports = __webpack_public_path__ + "static/media/comment-alt-edit.65830617.svg";